import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import CountDownReuse from './CountDownReuse';
import { shortenAddress } from '../candy-machine';

export interface MintProps {
  barf: any;
  itemsAvailable: any;
  startDate: any;
  itemsRemaining: any;
  balance: any;
  children: any;
  isActive: any;
  wallet: any;
}

const Mint = (props: MintProps) => {
  const { balance, itemsAvailable, itemsRemaining, startDate, isActive, wallet } = props;
  const theme = useTheme();
  const mediumDown = useMediaQuery(theme.breakpoints.down('sm'));

  const gridStyles = mediumDown ? {
    margin: '32px 0',
  } : {
    margin: '0',
  }

  const MintButtonContainer = () => <Grid item xs={12} md={5} style={{
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    ...gridStyles,
  }}>
    {props.children}
  </Grid>

  return (
    <>
      <Grid item xs={12}>
        <Typography gutterBottom variant='h2' align='center'>Adopt a Cat</Typography>
        {wallet ? (
          <Typography gutterBottom align='center'>{shortenAddress(wallet.publicKey.toBase58() || "")} Connected w/ Balance: {balance} SOL</Typography>
        ) : (
        <Typography gutterBottom align='center'>Connect your favorite solana wallet to purchase.</Typography>
        )}
      </Grid>

      {mediumDown && <MintButtonContainer />}
      <Grid item xs={12} md={5}>
        <Typography>
          <strong>Presale:</strong>
        </Typography>
        <Typography gutterBottom>
        &nbsp;&nbsp;Live now!
        </Typography>
        <Typography><strong>Presale Price:</strong></Typography>
        <Typography gutterBottom>&nbsp;&nbsp;0.05 SOL ($4)</Typography>
        <Typography><strong>Presale Supply:</strong></Typography>
        <Typography gutterBottom>&nbsp;&nbsp;100 Cats</Typography>
        {itemsRemaining > 0 && (
          <>
            <Typography><strong>Remaining:</strong></Typography>
            <Typography>&nbsp;&nbsp; {itemsRemaining - 9900} Cats</Typography>
          </>
        )}
      </Grid>
      {!mediumDown && <MintButtonContainer />}
    </>
  );
}

export default Mint;
